import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { CachedHttpClient } from '../common/utils';
import { AppConfig } from '../app-config';
import { APP_CONFIG } from '../app-config.token';
import { Observable } from 'rxjs';
import { WorkerAgreementDurationStatsDto } from '../models/dtos/statistics/worker-agreement/worker-agreement-duration-stats-dto';
import { Moment } from 'moment';

@Injectable({
  providedIn: 'root',
})
export class StatisticsService {
  private http = inject(HttpClient);
  private cachedHttp = inject(CachedHttpClient);
  private config = inject<AppConfig>(APP_CONFIG);

  private readonly API_URL = this.config.resourceApiURI;
  private readonly statisticsPath = '/statistics';

  private get statisticsUrl() {
    return this.API_URL + this.statisticsPath;
  }

  constructor() { }

  getWorkerAgreementDurationStats(
    employerId: number,
    employerObjectId: number | null,
    dateFrom: Moment | null,
    dateTo: Moment | null,
  ): Observable<WorkerAgreementDurationStatsDto> {
    const url = `${this.statisticsUrl}/workeragreement/duration`;

    let params = new HttpParams().set('employerId', employerId);
    if (employerObjectId) {
      params = params.set('employerObjectId', employerObjectId);
    }
    if (dateFrom) {
      params = params.set('dateFrom', dateFrom.toDate().toDateString());
    }
    if (dateTo) {
      params = params.set('dateTo', dateTo.toDate().toDateString());
    }

    return this.http.get<WorkerAgreementDurationStatsDto>(url, { params });
  }
}
